/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { SmartLink as Link } from '@/utils/smartLink';
import { type Locale } from '@/types/i18n';
import styles from './CustomFallbackList.module.scss';

const data = {
  'en-US': {
    header: 'Popular Parts',
    items: [
      {
        label: 'Air Filter',
        url: '/external-engine/air-filter',
      },
      {
        label: 'Antifreeze',
        url: '/antifreeze-radiator-additives-and-windshield-wash-fluid/antifreeze',
      },
      {
        label: 'Batteries',
        url: '/batteries-starting-and-charging/battery',
      },
      {
        label: 'Brakes',
        url: '/brakes-and-traction-control/brake-pads',
      },
      {
        label: 'Headlights',
        url: '/parts/electrical-and-lighting/headlight',
      },
      {
        label: 'Motor Oil',
        url: '/motor-oil-and-transmission-fluid/engine-oil',
      },
      {
        label: 'Spark Plugs',
        url: '/ignition-tune-up-and-routine-maintenance/spark-plug',
      },
      {
        label: 'Wiper Blades',
        url: '/ignition-tune-up-and-routine-maintenance/wiper-blade-windshield',
      },
    ],
  },
  'es-MX': {
    header: 'Artículos más buscados',
    items: [
      {
        label: 'Aceites',
        url: '/aceite-para-motor-y-aditivos-para-aceite/aceite-de-motor',
      },
      {
        label: 'Anticongelantes',
        url: '/anticongelante-aditivos-para-radiador-y-liquidos-limpiaparabrisas/anticongelante-refrigerante',
      },
      {
        label: 'Balatas',
        url: '/frenos-y-control-de-traccion/balata',
      },
      {
        label: 'Baterías',
        url: '/encendido-afinacion-y-mantenimiento-de-rutina/bateria',
      },
      {
        label: 'Bujías',
        url: '/encendido-afinacion-y-mantenimiento-de-rutina/bujia',
      },
      {
        label: 'Faros',
        url: '/partes-de-colision-carroceria-y-herrajes/faro-bulbo-delantero',
      },
      {
        label: 'Filtros de aire',
        url: '/filtros/filtro-de-aire',
      },
      {
        label: 'Limpiaparabrisas',
        url: '/encendido-afinacion-y-mantenimiento-de-rutina/limpiaparabrisas-hoja',
      },
    ],
  },
  'pt-BR': {
    header: 'Produtos mais pesquisados',
    items: [
      {
        label: 'Óleo de Motor',
        url: '/oleo-do-motor-e-fluido-da-transmissao/oleo-de-motor',
      },
      {
        label: 'Discos de Freio',
        url: '/controle-de-frenagem-e-tracao/disco-de-freio-dianteiro',
      },
      {
        label: 'Pastilhas de Freio',
        url: '/controle-de-frenagem-e-tracao/pastilha-de-freio-dianteira',
      },
      {
        label: 'Baterías',
        url: '/bateria-carregadores-e-auxiliares-de-partida/bateria',
      },
      {
        label: 'Velas Automotivas',
        url: '/ignicao-ajuste-e-manutencao-de-rotina/vela-de-ignicao',
      },
      {
        label: 'Lâmpadas',
        url: '/eletrica-e-iluminacao/lampada-farol-de-milha',
      },
      {
        label: 'Radiadores',
        url: '/controles-de-temperatura-e-aquecimento/radiador',
      },
      {
        label: 'Amortecedor',
        url: '/suspensao-direcao-pneu-e-roda/amortecedor-suspensao-dianteira',
      },
    ],
  },
};

// TODO: migrate to ContentStack

export function CustomFallbackList({ locale }: { locale: Locale }) {
  const fallbackList = data[locale];
  return (
    <div className={styles.partsContainer}>
      <div className={styles.partsHeader}>{fallbackList.header}</div>
      {fallbackList.items.map((item) => (
        <div className={styles.partsItems} key={item.url}>
          <Link className={styles.parts} to={item.url}>
            {item.label}
          </Link>
        </div>
      ))}
    </div>
  );
}
